import axiosInstance from '../helpers/axiosConfig';

class PaymentsService {
  static getConfig = (body) => axiosInstance.post('/payments/config', body);
  static getOfflinePayment = (body) => axiosInstance.post('/payments/offlinePayment', body);
  static createNestpayPayment = (body) => axiosInstance.post('/payments/nestpay/create', body, { responseType: 'text' });
  static getPaymentById = (id) => axiosInstance.get(`/payments/${id}`);
}

export default PaymentsService;
